import { Button } from '@repo/shadcn';
import { RotateCcw } from 'lucide-react';

import { useUrlFilter } from '@/hooks';

import { ButtonProps } from './button.interface';

interface ResetFilterButtonProps extends ButtonProps {}

export const ResetFilterButton = ({ size = 'sm' }: ResetFilterButtonProps) => {
    const { clearSearchFilters } = useUrlFilter();

    const handleResetFilters = () => {
        clearSearchFilters();
    };

    return (
        <Button variant="outline" size={size} onClick={handleResetFilters}>
            <RotateCcw className="" size={16} />
        </Button>
    );
};

ResetFilterButton.displayName = 'ResetFilterButton';
